export enum GeneratedDocumentProcedureRecordType {
  ProcedureNote = 'procedure_note',
  Procedure = 'procedure',
}
